<template>
    <div class="layer-root" ref="rootElement">
        <div class="pivot" ref="pivotDiv" id="pivotDiv"></div>
        <img class="background-image" :src="layer.image.data" :style="{ '--levelofDepth': layer.level, '--imgWidth': imageSizeInPx.width, '--offsetLeft': offsetLeftMobile }"
            ref="backgroundImage" @load="handleImageLoaded" />
        <DashboardElement v-for="element in layer.elements"
            :key="`${element.id}-${imageSize.width}-${imageSize.height}`" :element="element" :level="layer.level"
            :layerSize="imageSize" :layerWidthOriginal="layerWidthOriginal" :layerHeightOriginal="layerHeightOriginal" :isPreview="isPreview" :isMobileDevice="isMobileDevice" />
    </div>
</template>

<script>
import DashboardElement from "@components/DashboardElement.vue"
import getEnv from '@/utils/env'
export default {
    props: {
        layer: {
            type: Object,
            required: true,
        },
        isPreview: {
            type: Boolean,
            required: false
        },
        isMobileDevice: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        DashboardElement
    },
    data() {
        return {
            imageSize: { width: 0, height: 0 },
            imageSizeInPx: { width: "0px", height: "0px" },
            containerWidth: '100%',
            containerHeight: '100%',
            resizeObserver: null,
            offsetLeftMobile: parseFloat(getEnv('VUE_APP_OFFSET_LEFT_MOBILE')) || 0,
            layerHeightOriginal: 0,
            layerWidthOriginal: 0
        }
    },
    mounted() {
        this.setupResizeObserver()
        this.updateDimensions()
        const img = new Image()
        img.src = this.layer.image.data
        img.onload = () => {
            this.layerWidthOriginal = img.width
            this.layerHeightOriginal = img.height
        }
    },
    beforeUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        }
    },
    methods: {
        handleImageLoaded() {
        // Emit an event to notify the parent component that the image has loaded
        this.$emit('backgroundImageLoaded', this.$refs.backgroundImage.offsetWidth)
        },
        updateDimensions() {
            const backgroundImage = this.$refs.backgroundImage
            if (backgroundImage) {
                const width = backgroundImage.offsetWidth
               // const height = width / (window.screen.width / window.screen.height)
                const height = width / (16 / 9)
                this.containerWidth = `${width}px`
                this.containerHeight = `${height}px`
            }
        },
        setupResizeObserver() {
            const backgroundImage = this.$refs.backgroundImage
            if (backgroundImage) {
                this.resizeObserver = new ResizeObserver(entries => {
                    requestAnimationFrame(() => {
                        this.updateDimensions()
                        for (let entry of entries) {
                            this.imageSize = {
                                width: entry.contentRect.width,
                                height: entry.contentRect.height
                            }
                            //console.log(this.imageSize)
                            this.imageSizeInPx = {
                                width: entry.contentRect.width + "px",
                                height: entry.contentRect.height + "px"
                            }
                        }
                    })
                })
                this.resizeObserver.observe(backgroundImage)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.layer-root {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.background-image {
    position: absolute;
    left: 0;
    top: 0;
    width: var(--container-width, 100%);
    height: var(--container-height, 100%);
    z-index: var(--levelofDepth);
    object-fit: fill;
}

@media screen and (max-width: 600px) and (orientation: portrait) {

    .layer-root {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        //aspect-ratio: 16 / 9;
        overflow: hidden;
    }

    .background-image {
        position: absolute;
        left: calc(var(--imgWidth) * var(--offsetLeft) * -1);
        top: 0;
        width: auto;
        height: 100%;
        z-index: var(--levelofDepth);
        object-fit: fill;
    }
    .pivot {
        position: absolute;
        width: 1px;
        height: 100%;
        left: 72%;
    }
}
</style>
